<template>
  <popup :showFlag="showFlag"
         @onShowpop="onShowpop">
    <div class="ruletp" :style="{'height': ruleHeight+'px'}" @click.stop="rf">
      <div class="rtpdown" @click="onShowpop"></div>
      <div class="scrollbar"
           ref="scrollbar"
           v-infinite-scroll="loadMore"
           infinite-scroll-distance="10"
           infinite-scroll-disabled="ruleTp.isLoading">
        <div class="rtpsh" id="topsearch">
          <img src="@/assets/search.png" class="rtpsimg" />
          <input class="rtpipt" v-model="ruleTp.keyword" @input="iptfn($event)" placeholder="搜索您想拍摄的规格名称、尺寸"/>
          <img mode="widthFix" src="@/assets/close.png" @click="closeipt" class="rtpclose" />
        </div>
        <div v-show="!ruleTp.keyword">
          <mt-swipe :auto="0" :defaultIndex="current" class="rtpswip">
            <mt-swipe-item v-for="(item, index) in ruleTp.rulestyle" :key="index">
              <div class="rtptop">
                <div v-for="sample in item" @click="selType(sample.id)" class="rtpiconlist" :class="[sample.id === ruleTp.selId ? 'activeRtpiconlist' : '']" :key="sample.id">
                  <div class="rtpicon">
                    <img :src="sample.url" class="rptimg"/>
                  </div>
                  {{sample.name}}
                </div>
              </div>
            </mt-swipe-item>
          </mt-swipe>
        </div>
        <div class="rtptitle" v-show="!ruleTp.keyword">
          {{ruleTp.allList[ruleTp.selId].name}}
        </div>
        <div v-show="!ruleTp.keyword && sample.id === ruleTp.selId" v-for="sample in ruleTp.allList" :key="sample.id">
          <div v-for="(item, index) in sample.list" :key="item.spec_id" class="rtpculist" @click="ruledetail(item.spec_id)">
            <img src="https://leqi-public.oss-cn-shanghai.aliyuncs.com/applet_category/ZuiMei/usual.png"  class="rtptou" />
            <div class="rtpmiddle oneline">
              {{item.name}}
              <img v-if="sample.id === 0 && index <= 1" src="@/assets/huo.png" class="huoimg"/>
              <div class="rtpmc oneline">
                {{item.width_px}} x {{item.height_px}} px | {{item.width_mm}} x {{item.height_mm}} mm | {{item.file_size_min | showSize(item.file_size_max)}}
              </div>
            </div>
            <img src="@/assets/right.png" class="rtpright"/>
          </div>
        </div>
        <div v-for="item in ruleTp.search.list" :key="'search' + item.spec_id" v-show="ruleTp.keyword">
          <div class="rtpculist" @click="ruledetail(item.spec_id)">
            <img src="https://leqi-public.oss-cn-shanghai.aliyuncs.com/applet_category/ZuiMei/usual.png"  class="rtptou" />
            <div class="rtpmiddle oneline">
              {{item.name}}
              <div class="rtpmc oneline">
                {{item.width_px}} x {{item.height_px}} px | {{item.width_mm}} x {{item.height_mm}} mm | {{item.file_size_min | showSize(item.file_size_max)}}
              </div>
            </div>
            <img src="@/assets/right.png" class="rtpright" />
          </div>
        </div>
        <search-rule :searchStatus="ruleTp.searchStatus" @goautospec="goautospec"></search-rule>
      </div>
    </div>
  </popup>
</template>

<script>
import popup from './popup'
import searchRule from './searchRule/searchRule'
import { Swipe, SwipeItem } from 'mint-ui'
import { mapState } from 'vuex'
export default {
  name: 'rule',
  data () {
    return {
      ruleHeight: 0,
      current: 0
    }
  },
  props: {
    showFlag: {
      type: Boolean,
      default: false
    },
    ruleTp: {
      type: Object,
      default: () => {
        return {
          keyword: '',
          rulestyle: [],
          selId: 0,
          search: {
            pageIndex: 1,
            pageTotal: 0,
            list: []
          },
          allList: [{
            pageIndex: 1,
            pageTotal: 0,
            id: 1,
            list: []
          }],
          touimg: '',
          isLoading: false,
          isFinish: false,
          searchStatus: 0 // 0为不显示状态图，1为没有找到规格图，2为努力加载图，3为检查网络图，4为出错图
        }
      }
    }
  },
  deactivated () {
    this.current = 0
  },
  activated () {
    if (!this.actiBol) {
      return
    }
    this.setHeight()
  },
  methods: {
    loadMore () {
      this.$emit('onQuerylist')
    },
    ruledetail (specid) {
      this.$emit('onRuledetail', specid)
    },
    goautospec () {
      this.$emit('goautospec')
    },
    onShowpop (bol) {
      this.$refs.scrollbar.scrollTop = 0
      this.$emit('onControlRule')
    },
    iptfn (e) {
      const { value } = e.target
      this.$emit('onChangeKey', value)
    },
    selType (defaultid) {
      const { selId } = this.ruleTp
      if (selId === defaultid) {
        console.log('重复点击了')
        return
      }
      this.$emit('onSelType', defaultid)
    },
    setHeight () {
      const h = window.screen.availHeight
      this.ruleHeight = h * 0.75
    },
    rf () {
      return false
    },
    closeipt () {
      this.$emit('onChangeKey', '')
    }
  },
  computed: {
    ...mapState(['actiBol'])
  },
  components: {
    popup,
    mtSwipe: Swipe,
    mtSwipeItem: SwipeItem,
    searchRule
  },
  filters: {
    showSize (min, max) {
      return min && max ? `${parseInt(min / 1024)}~${parseInt(max / 1024)}KB` : min && !max ? `不小于${parseInt(min / 1024)}KB` : !min && max ? `不大于${parseInt(max / 1024)}KB` : '无要求'
    }
  }
}
</script>

<style>
.ruletp .mint-swipe-indicator.is-active {
  background: #4710ED;
  opacity: 1;
}
</style>

<style scoped>
.ruletp{
  background-color: white;
  padding:0 .32rem;
  box-sizing: border-box;
  border-top-left-radius: .48rem;
  border-top-right-radius: .48rem;
  display: flex;
  flex-direction: column;
}
.rtpdown{
  height:.48rem;
  background-image: url('~@/assets/down.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: .8rem .16rem;
  flex-shrink: 0;
}
.scrollbar{
  overflow: auto;
}
.activeRtpiconlist{
  color:#5400F7!important;
}
.activeRtpiconlist .rtpicon{
  border-color:#5400F7!important;
}
.rtpsh{
  display: flex;
  display: -webkit-flex;
  background-color: #F5F7FA;
  border-radius: .16rem;
  align-items: center;
  height: .8rem;
  box-sizing: border-box;
  padding: 0 .32rem;
  justify-content: space-between;
  margin-bottom: .32rem;
}
.rtpsimg{
  width:.32rem;
  flex-shrink: 0;
}
.rtpclose{
  width:.48rem;
  flex-shrink: 0;
  border:.1rem solid transparent;
}
.rtpipt{
  flex-grow: 1;
  border: none;
  margin: 0 .16rem;
  background-color: transparent;
  font-size: .26rem;
  white-space: .36rem;
}
.rtptop{
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.rtpiconlist{
  flex-shrink: 0;
  flex-basis: 25%;
  text-align: center;
  font-size: .24rem;
  color:#303133;
  margin-bottom: .32rem;
}
.rtpswip{
  height:3.8rem!important;
}
.rtpicon{
  width:.96rem;
  height:.96rem;
  border-radius: 50%;
  border:.02rem solid #E5E5EA;
  margin: 0 auto .12rem;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.rptimg{
  width:.48rem;
  height:.48rem;
  object-fit: contain;
}
.rtptitle{
  font-size: .34rem;
  color: #303133;
  font-weight: bold;
  border-bottom: .02rem solid #E5E5EA;
  padding-bottom: .32rem;
}
.rtpculist{
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding-left:.16rem;
  height:1.46rem;
  align-items: center;
}
.rtptou{
  flex-shrink: 0;
  width:.64rem;
  height:.64rem;
  object-fit: contain;
  margin-right: .48rem;
}
.rtpright{
  flex-shrink: 0;
  width:.32rem;
}
.rtpmiddle{
  flex-grow: 1;
  overflow: hidden;
  font-size: .28rem;
  color:#303133;
  font-weight: bold;
}
.huoimg{
  width: .24rem;
  margin-left: .12rem;
}
.rtpmc{
  font-size: .24rem;
  opacity: 0.5;
  margin-top: .1rem;
}
</style>
